// Canonical global role names - mirror of backend config/constant.js USER_ROLES.
export const USER_ROLES = {
	SUPER_ADMIN: "SUPER_ADMIN",
	ADMIN: "ADMIN",
	EMPLOYEE: "EMPLOYEE",
	API_USER: "API_USER",
};
